<template>
  <img :src="url" alt="" :class="[SHAPES[shape] ?? SHAPES.circle, 'flex-shrink-0 object-cover']" :style="{ width: `${size}px`, height: `${portrait ? Math.round(size * 1.28) : size}px` }">
</template>

<script setup>
// The resume's picture. `portrait` makes it passport shaped (3.5 x 4.5), as a German CV expects.
defineProps({
  url: { type: String, required: true },
  shape: { type: String, default: 'circle' }, // circle | rounded | square
  size: { type: Number, default: 88 }, // the width, in px
  portrait: { type: Boolean, default: false },
})

const SHAPES = { circle: 'rounded-full', rounded: 'rounded-xl', square: '' }
</script>
